import EN from '~/assets/strings/en.json';
import ID from '~/assets/strings/id.json';

export enum Language {
  EN = 'en',
  ID = 'id',
}

const dictionary = {
  [Language.EN]: EN as Record<string, string>,
  [Language.ID]: ID as Record<string, string>,
};

let currentLang = Language.ID;

const setLanguage = (lang: Language) => {
  if (Object.keys(dictionary).includes(lang)) {
    currentLang = lang;
    window.localStorage.language = lang;
  } else {
    throw new Error('Failed to change to language: ' + lang);
  }
};

const t = function (key: string, data?: Record<string, any>) {
  const dict = dictionary[currentLang];
  if (dict == null) {
    throw new Error('Languate is missing');
  }
  let result = dict[key];
  if (result == null) {
    return key;
  }

  if (data) {
    Object.keys(data).forEach((dataKey) => {
      const value = data[dataKey];
      const template = `{${dataKey}}`;
      result = result.replace(template, value);
    });
  }
  return result;
};

export default {
  t,
  setLanguage,
};
